import { Component, ChangeDetectionStrategy, HostBinding, Input } from '@angular/core';

@Component({
    selector: 'ppl-form-column',
    templateUrl: './form-column.component.html',
    styleUrls: ['./form-column.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PplFormColumnComponent {

  @Input() @HostBinding('style.flex') flex: string;
  @Input() @HostBinding('class.no-margin') noMargin = false;

}
